import type { ChartScale } from "../core/chart.ts";

const Trim = (v: number, digits: number) => String(+v.toFixed(digits));

export function FormatHz(v: number): string {
  return v >= 1000 ? `${Trim(v / 1000, 1)}k` : `${Math.round(v)}`;
}

export function FormatDb(v: number): string {
  return `${Trim(v, 1)}dB`;
}

export function FormatPct(v: number): string {
  return `${Math.round(v * 100)}%`;
}

export function FormatSeconds(span: number): (v: number) => string {
  if (span < 0.01) return (v) => `${Trim(v * 1000, 2)}ms`;
  if (span < 0.1) return (v) => `${Trim(v * 1000, 1)}ms`;
  if (span < 2) return (v) => `${Math.round(v * 1000)}ms`;
  if (span < 20) return (v) => `${Trim(v, 1)}s`;
  return (v) => `${Math.round(v)}s`;
}

export function TimeTickFormat(scale: ChartScale): (v: number) => string {
  const [t0, t1] = scale.domain();
  return FormatSeconds(Math.abs(t1 - t0));
}

export function HzTickFormat(_scale: ChartScale): (v: number) => string {
  return FormatHz;
}
